// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientQuestionnaire_root__3vjQm","header":"PatientQuestionnaire_header__33-kr","info":"PatientQuestionnaire_info__2Khp7"};